import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5896ceb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inline-row" }
const _hoisted_2 = { class: "align-right" }
const _hoisted_3 = { style: 'height:42vh' }
const _hoisted_4 = {
  class: "custom-cell",
  id: "includeCell"
}

import { computed, inject, ref, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxColumn } from "devextreme-vue/cjs/data-grid";
import { DxToolbarItem } from "devextreme-vue/popup";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { RequestQuotation } from "@/types/work-orders/RequestQuotation";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import SelectContractorModal from "@/components/work-orders/select-contractor-modal.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { Contacts } from "acquaint-api/models/Contacts";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import { Templates } from "@/enums/constants/Templates";
import { useSystemConfigurationStore } from "@/stores/SystemConfigurationStore";
import { SystemConfiguration } from "acquaint-api/constants/SystemConfiguration";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { WorkOrderQueueQuatation } from "@/types/work-orders/WorkOrderQueueQuatation";
import EmailFormModal from "@/components/email/email-form-modal.vue";
import { DxContextMenu } from "devextreme-vue/context-menu";
import { ContextMenuItem } from "@/types/ui/menus/ContextMenuItem";


export default /*#__PURE__*/_defineComponent({
  __name: 'work-order-quotation-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The work order id.
   * @type {number}
   * @required
   */
  workOrderId: {
    type: Number,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Emitted when the email has been sent.
   * This can be used to notify the parent component that the email has been sent.
   */
  "quotationEmailSent",
  /**
   * Emitted when the modal is closed.
   * This can be used to notify the parent component that the modal has been dismissed.
   */
  "modalClosed",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const acquaintNextClient = inject(
  "AcquaintApiNextClient",
) as AcquaintApiNextClient;
const emailConfirmationTemplate = ref<IDDescriptionPair>({
  id: -1,
  description: "",
});
const displaySelectContractorModal = ref(false);
const requestQuotations = ref<RequestQuotation[]>([]);
const contractorIds = ref<number[]>([]);
const searching = ref(false);
const previewEmail = ref(false);
const displayEmailModal = ref(false);
const emailCredits = ref(0);
const pdfFile = ref<File>();
const initialDefaultRequestQuotation = (): RequestQuotation => ({
  id: 0,
  contractorName: "",
  email: "",
  include: false,
});
const selectedRequestQuotationItem = ref<RequestQuotation>(
  initialDefaultRequestQuotation(),
);
const systemConfigurationStore = useSystemConfigurationStore();
const showFunctionsMenu = ref(false);
const contextMenuId = ref("work-order-quotation-modal-menu");
const disableRemoveContractorOption = computed(() => {
  return selectedRequestQuotationItem.value?.id == 0;
});

watch(
  () => showModal.value,
  async () => {
    if (!showModal.value) {
      return;
    }
    contextMenuId.value = `${contextMenuId.value}-${Date.now()}`;
    selectedRequestQuotationItem.value = initialDefaultRequestQuotation();
    contractorIds.value = [];
    requestQuotations.value = [];

    await getEmailCredits();
    emailConfirmationTemplate.value = await fetchEmailTemplateById(
      Templates.WorkOrderQuoteRequest,
    );
    previewEmail.value =
      (await systemConfigurationStore.getSystemConfigurationValue(
        SystemConfiguration.PreviewBeforeSendingWorkOrders,
      )) === "1"
        ? true
        : false;
  },
);

const getEmailCredits = async () => {
  try {
    emailCredits.value = await acquaintNextClient.httpGet(
      "/Email/getemailcreditbalance",
    );
  } catch (err) {
    emailCredits.value = 0;
    displayErrorMessage(getErrorMessage(err));
  }
};

const queueWorkOrderQuotation = async (quotation: WorkOrderQueueQuatation) => {
  try {
    await acquaintNextClient.httpPost<WorkOrderQueueQuatation>(
      "/WorkOrders/QueueWorkOrderQuote",
      quotation,
    );
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const fetchEmailTemplateById = async (id: number) => {
  try {
    if (id == undefined) return { id: -1, description: "" };

    return await acquaintApiClient.httpGet<IDDescriptionPair>(
      `app/system/lookup/${LookupTableSource.EmailTemplates}/${id}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return { id: -1, description: "" };
  }
};

const onAddContractor = () => {
  displaySelectContractorModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
};

const onRowSelect = (e: RequestQuotation) => {
  setTimeout(() => {
    if (e) {
      selectedRequestQuotationItem.value = e;
    }
  }, 100);
};

const onSelectContractor = async (contractors?: IDDescriptionPair[]) => {
  if (!contractors || contractors.length === 0) {
    return;
  }

  const contractorDetails = await Promise.all(
    contractors.map((c) => fetchContractorById(c.id)),
  );

  contractorDetails.forEach((contractor) => {
    if (
      contractor &&
      !requestQuotations.value.some((q) => q.id === contractor.id)
    ) {
      requestQuotations.value = [
        ...requestQuotations.value,
        {
          id: contractor.id,
          contractorName: formatContactName(contractor),
          email: contractor.email,
          include: contractor.email ? true : false,
        },
      ];
    }
  });
};

const formatContactName = (contractor: Contacts) => {
  if (contractor.businessCompany) {
    return `${contractor.firstNames} ${contractor.lastName} (${contractor.businessCompany})`;
  } else {
    return `${contractor.firstNames} ${contractor.lastName}`;
  }
};

const fetchContractorById = async (
  contactId: number,
): Promise<Contacts | undefined> => {
  try {
    if (contactId > 0) {
      const contact = await acquaintApiClient.httpGet<Contacts>(
        `database/contacts/${contactId}`,
      );
      return contact;
    }
  } catch (ex) {
    displayErrorMessage(getErrorMessage(ex));
    return undefined;
  }
};

const onRemoveContractor = () => {
  if (selectedRequestQuotationItem.value.id > 0) {
    requestQuotations.value = requestQuotations.value.filter(
      (q) => q.id !== selectedRequestQuotationItem.value.id,
    );
  }
  selectedRequestQuotationItem.value = initialDefaultRequestQuotation();
};

const onSendClick = async () => {
  const queueQuotation: WorkOrderQueueQuatation = {
    workOrderId: props.workOrderId,
    emailTemplateId: emailConfirmationTemplate.value.id,
    contractorIds: requestQuotations.value
      .filter((rq) => rq.include)
      .map((rq) => rq.id),
  };

  contractorIds.value = queueQuotation.contractorIds;

  if (!previewEmail.value) {
    if (await queueWorkOrderQuotation(queueQuotation)) {
      emit("quotationEmailSent");
      showModal.value = false;
    }
  } else {
    await attachWorkOrderQuotePdf();
    displayEmailModal.value = true;
  }
};

const createWorkOrderQuotePdf = async (): Promise<Blob | undefined> => {
  try {
    return await acquaintApiClient.getFile(
      `app/workorders/${props.workOrderId}/createQuotePdf`,
    );
  } catch (err) {
    displayErrorMessage("The work order quote PDF file could not be created.");
    return;
  }
};

const attachWorkOrderQuotePdf = async () => {
  const pdfBlob: Blob | undefined = await createWorkOrderQuotePdf();
  if (!pdfBlob) {
    pdfFile.value = undefined;
    return;
  }

  pdfFile.value = new File(
    [pdfBlob],
    `QuotationRequest-${props.workOrderId}.pdf`,
    {
      type: "application/pdf",
    },
  );
};

const pdfFileToDisplayInEmail = computed(() => {
  return pdfFile.value ? [pdfFile.value] : [];
});

const disableToggle = (item: RequestQuotation) => {
  return !item.email;
};

const hasIncludedItem = computed(() => {
  return requestQuotations.value.some(
    (quotation) => quotation.include === true,
  );
});

const menuItems = computed(() => {
  const menu: ContextMenuItem[] = [
    {
      text: "Add Contractor",
      key: "addContractor",
      disabled: false,
      icon: "",
    },
    {
      text: "Remove Contractor",
      key: "removeContractor",
      disabled: disableRemoveContractorOption.value,
      icon: "",
    },
  ];
  return menu;
});
const onMenuItemClick = (e: any) => {
  switch (e.itemData.key) {
    case "addContractor":
      onAddContractor();
      break;
    case "removeContractor":
      onRemoveContractor();
      break;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
      title: "Request Quotations",
      height: "650",
      onModalClosed: closeModal
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(LookupSingleSelect, {
            label: "Email Template",
            "lookup-source": _unref(LookupTableSource).EmailTemplates,
            modelValue: emailConfirmationTemplate.value.id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailConfirmationTemplate.value.id) = $event))
          }, null, 8, ["lookup-source", "modelValue"]),
          _createVNode(AcquaintInfoBox, {
            text: emailCredits.value.toString(),
            label: "Email Credits Remaining"
          }, null, 8, ["text"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SwitchToggle, {
            label: "Preview Before Sending",
            modelValue: previewEmail.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((previewEmail).value = $event)),
            readOnly: false
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(GridBase, {
            "data-source": requestQuotations.value,
            "id-column-name": "id",
            loading: searching.value,
            "word-wrap-enabled": true,
            customColumnSlots: ['includeCell'],
            onRowSelected: onRowSelect
          }, {
            columns: _withCtx(() => [
              _createVNode(_unref(DxColumn), {
                "data-field": "id",
                caption: "Id",
                visible: false
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "contractorName",
                caption: "Contractor",
                "hiding-priority": 7,
                width: "200px"
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "email",
                caption: "Email",
                "hiding-priority": 6
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "include",
                caption: "Include",
                "cell-template": "includeCell",
                width: "80px"
              })
            ]),
            includeCellData: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(SwitchToggle, {
                  modelValue: data.include,
                  "onUpdate:modelValue": ($event: any) => ((data.include) = $event),
                  readOnly: disableToggle(data)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "readOnly"])
              ])
            ]),
            _: 1
          }, 8, ["data-source", "loading"])
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          elementAttr: { id: contextMenuId.value },
          text: 'Actions',
          onClick: () => {
            showFunctionsMenu.value = !showFunctionsMenu.value;
          },
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Send',
          disabled: !hasIncludedItem.value,
          onClick: () => onSendClick(),
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: { text: 'Cancel', onClick: () => closeModal() }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(SelectContractorModal, {
      modelValue: displaySelectContractorModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((displaySelectContractorModal).value = $event)),
      onSelectContractor: onSelectContractor
    }, null, 8, ["modelValue"]),
    _createVNode(EmailFormModal, {
      modelValue: displayEmailModal.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((displayEmailModal).value = $event)),
      emailTemplateId: Number(emailConfirmationTemplate.value.id),
      "contact-list": contractorIds.value,
      workOrderId: __props.workOrderId,
      onEmailSent: _cache[5] || (_cache[5] = ($event: any) => (emit('quotationEmailSent'))),
      onModalClosed: _cache[6] || (_cache[6] = ($event: any) => (emit('modalClosed'))),
      "default-files": pdfFileToDisplayInEmail.value
    }, null, 8, ["modelValue", "emailTemplateId", "contact-list", "workOrderId", "default-files"]),
    _createVNode(_unref(DxContextMenu), {
      visible: showFunctionsMenu.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((showFunctionsMenu).value = $event)),
      "data-source": menuItems.value,
      target: `#${contextMenuId.value}`,
      position: { my: 'bottom right', at: 'top right' },
      onItemClick: onMenuItemClick
    }, null, 8, ["visible", "data-source", "target"])
  ], 64))
}
}

})